import React, { useContext, useEffect, useState } from "react";
import Timer from "../../components/timer/Timer";
import ButtonPrimary from "../../components/buttons/ButtonPrimary";
import axios from "axios";
import { ConnectionStatusContext } from "../../provider/ConnectionStatusProvider";
import {
  doc,
  getDoc,
  onSnapshot,
  arrayUnion,
  updateDoc,
  setDoc,
} from "firebase/firestore";
import { db } from "../../firebaseConfig";
import TotalValue from "./TotalValue";
import AmountDisplay from "../../components/common/AmountDisplay";

type MyComponentProps = {
  calculateSumOfValues: any;
  totalValue: any;
  setTotalValue: any;
  setTotalStalked: any;
  totalStacked: any;
};

export const Ruins: React.FC<MyComponentProps> = ({
  calculateSumOfValues,
  totalValue,
  setTotalValue,
  setTotalStalked,
  totalStacked,
}) => {
  const [myRuins, setMyRuins] = useState<any>(null);
  const [user, setUser] = useState<any>(null);
  const [runes2, setRunes] = useState<any>();
  const connectionStatus = useContext(ConnectionStatusContext);

  const convertTimestamp = (timestamp: any): string => {
    const date = timestamp.toDate();

    return date.toString(); // This converts to the desired format
  };

  const getData = (
    collectionName: string,
    id: string,
    callback: (data: any | undefined) => void
  ) => {
    const docRef = doc(db, collectionName, id);

    const unsubscribe = onSnapshot(
      docRef,
      (docSnap) => {
        if (docSnap.exists()) {
          callback(docSnap.data() as any);
        } else {
          console.log("No such document!");
          callback(undefined);
        }
      },
      (error) => {
        console.error("Error getting real-time updates: ", error);
        callback(undefined);
      }
    );

    return unsubscribe;
  };

  useEffect(() => {
    if (connectionStatus && connectionStatus.isConnected === true) {
      let acc =
        connectionStatus?.type === "xverse"
          ? connectionStatus?.accounts.find((v) => v.purpose === "ordinals")
          : connectionStatus?.accounts;
      setUser(acc);
    }
  }, [connectionStatus, connectionStatus?.isConnected]);

  const addDocument = async (id: string, data: any) => {
    try {
      const submitData = { ...data, stackedAt: new Date() };
      const docRef = doc(db, "Ruins", id);
      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
        await updateDoc(docRef, {
          stalkedItems: arrayUnion(submitData),
        });
        console.log("Document updated with new data in array.");
      } else {
        await setDoc(docRef, {
          stalkedItems: [submitData],
        });
        console.log("Document created and new data added to array.");
      }
    } catch (error) {
      console.error("Error updating document: ", error);
    }
  };
  const calculateValueFromTimestamp = (timestamp: any): number => {
    console.log("timeStamp", timestamp);
    // Get the current time in seconds since epoch
    const currentTimeSeconds = Math.floor(Date.now() / 1000);

    // Calculate the difference in seconds between current time and provided timestamp
    const timestampSeconds = timestamp.seconds;
    const differenceSeconds = currentTimeSeconds - timestampSeconds;

    // Calculate the difference in hours
    const differenceHours = Math.floor(differenceSeconds / 3600);

    // Calculate the value as a multiple of 20 for each hour passed
    const value = differenceHours * 20;

    return value;
  };

  const handleStakeUnstakeCollection = (
    index: number,
    collection: any,
    stalkedItem: any
  ) => {
    if (
      myRuins?.stalkedItems?.find(
        (v: any) => v.rune_name === collection?.rune_name
      )
    ) {
      if (window.confirm("Are you sure you want to unstake?")) {
        console.log("collectionTo", collection);
        const value = calculateValueFromTimestamp(stalkedItem.stackedAt);
        if (connectionStatus?.type === "xverse") {
          removeItemFromStalkedItems(
            user?.address,
            collection?.rune_name,
            value
          );
        } else {
          removeItemFromStalkedItems(user, collection?.rune_name, value);
        }
      }
    } else {
      if (connectionStatus?.type === "xverse") {
        addDocument(user?.address, collection);
      } else {
        addDocument(user, collection);
      }
    }
  };
  const removeItemFromStalkedItems = async (
    documentId: string,
    rune_name: string,
    valueAdded: any
  ): Promise<void> => {
    try {
      // Create a reference to the document
      const docRef = doc(db, "Ruins", documentId);

      // Fetch the document snapshot
      const docSnap: any = await getDoc(docRef);
      if (!docSnap.exists()) {
        throw new Error(`Document with id ${documentId} does not exist.`);
      }

      // Extract the stalkedItems array and Value from the document data
      let { stalkedItems, Value } = docSnap.data() || {
        stalkedItems: [],
        Value: 0,
      };

      // Find the index of the item to remove based on name
      const indexToRemove = stalkedItems.findIndex(
        (item: any) => item.rune_name === rune_name
      );
      if (indexToRemove === -1) {
        throw new Error(`Item with name ${rune_name} not found.`);
      }

      // Remove the item from the array
      stalkedItems.splice(indexToRemove, 1);

      // Update the Value variable or add it with a value of 20
      if (typeof docSnap.data()?.Value === "number") {
        Value = docSnap.data()!.Value! + valueAdded;
      } else {
        Value = valueAdded;
      }

      // Update the document with the modified stalkedItems array and Value
      await updateDoc(docRef, { stalkedItems, Value });

      console.log(
        `Item with name ${rune_name} removed successfully from document ${documentId}.`
      );
    } catch (error: any) {
      console.error("Error removing item:", error.message);
    }
  };

  useEffect(() => {
    if (user) {
      let address = connectionStatus?.type === "xverse" ? user?.address : user;
      const unsubscribe = getData("Ruins", address, (newData) => {
        const totalValueRuins = newData?.Value
          ? calculateSumOfValues(newData?.stalkedItems) + newData?.Value
          : calculateSumOfValues(newData?.stalkedItems);
        console.log("TotalValue", totalValueRuins, totalValue);
        setTotalValue(totalValueRuins);
        setMyRuins(newData);
        setTotalStalked(newData?.stalkedItems?.length);
      });

      // Cleanup subscription on unmount
      return () => unsubscribe();
    }
  }, [user]);

  useEffect(() => {
    if (user) {
      let address = connectionStatus?.type === "xverse" ? user?.address : user;
      axios
        // .get(`https://softstake-backend.vercel.app/getRunes/${address}`)
        .get(`https://softstake-backend.vercel.app/getRunes/${address}`)
        // .get(
        //   `https://api.allorigins.win/raw?url=${encodeURIComponent(
        //     `https://api-mainnet.magiceden.io/v2/ord/btc/runes/wallet/activities/${address}`
        //   )}`
        // )

        .then((res) => {
          console.log("res-ruins", res);
          // let filtered = res?.data?.filter(
          //   (v: any) =>
          //     v?.kind === "buying_broadcasted" || v?.kind === "received"
          // );
          setRunes(res?.data?.data);
          // setData(res?.data);
        })
        .catch((err) => console.log("error", err));
    }
    // setUser(acc);
  }, [user]);

  return (
    <figure className="mb-10">
      <h2 className="mb-6 text-3xl md:text-4xl font-bold text-white capitalize">
        Runes
      </h2>

      <div className="p-4 bg-gray-900 rounded-lg border border-primary">
        <div className="text-right font-semibold text-lg">
          Total Bal: <TotalValue showRuneBal />
        </div>
        <div className="w-full mt-6 pb-6 overflow-x-auto">
          <table className="w-full min-w-max">
            <thead>
              <tr className="text-left">
                <th className="p-0">
                  <div className="py-3 px-6 bg-body rounded-tl-lg">
                    <span className="text-sm text-gray-300 font-semibold uppercase">
                      Rune
                    </span>
                  </div>
                </th>
                <th className="p-0">
                  <div className="py-3 px-6 bg-body">
                    <span className="text-sm text-gray-300 font-semibold uppercase">
                      Bal
                    </span>
                  </div>
                </th>
                <th className="p-0">
                  <div className="py-3 px-6 bg-body">
                    <span className="text-sm text-gray-300 font-semibold uppercase">
                      Stack Timer
                    </span>
                  </div>
                </th>
                <th className="p-0 text-right">
                  <div className="bg-body rounded-tr-lg">
                    <div className="py-3 px-6 text-center bg-body rounded-tr-lg ml-auto max-w-44">
                      <span className="text-sm text-gray-300 font-semibold uppercase">
                        Action
                      </span>
                    </div>
                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
              {runes2 &&
                runes2.map((rune: any, index: any) => (
                  <tr
                    key={index}
                    className={index % 2 === 0 ? "bg-gray-800" : "bg-gray-900"}
                  >
                    <td className="p-0">
                      <div className="flex items-center h-16 px-6">
                        <div className="flex items-center gap-3">
                          {/* <div className="w-12 h-12 bg-gray-600 rounded-full">
                          <img
                            src={rune.imageURI}
                            alt={rune.rune}
                            className="w-full h-full object-cover rounded-full"
                          />
                        </div> */}
                          <span className="text-sm text-gray-100 font-bold">
                            {rune.rune_name}
                          </span>
                        </div>
                      </div>
                    </td>

                    <td className="p-0">
                      <div className="flex items-center h-16 px-6">
                        <span className="text-sm text-gray-100 font-medium">
                          {rune.balance}
                          {/* <AmountDisplay amount={rune.balance} /> */}
                        </span>
                      </div>
                    </td>
                    <td className="p-0">
                      <div className="flex items-center px-6">
                        {/* {stakedRunes[index] ? (
                        <Timer startTime={startTimeRunes[index]} />
                      ) : (
                        <div className="text-center font-medium">
                          <span>0d </span> <span>0h </span> <span>0m </span>{" "}
                          <span>0s</span>
                        </div>
                      )} */}
                        {myRuins?.stalkedItems?.find(
                          (v: any) => v.rune_name === rune?.rune_name
                        ) ? (
                          <div>
                            {/* {convertTimestamp(
                        myStakes?.stalkedItems?.find(
                          (v: any) =>
                            v.creatorTipsAddress ===
                            collection?.creatorTipsAddress
                        )?.stackedAt
                      )} */}
                            <Timer
                              startTime={convertTimestamp(
                                myRuins?.stalkedItems?.find(
                                  (v: any) => v.rune_name === rune?.rune_name
                                )?.stackedAt
                              )}
                            />
                          </div>
                        ) : (
                          <div className="text-center font-medium">
                            <span>0d </span> <span>0h </span> <span>0m </span>{" "}
                            <span>0s</span>
                          </div>
                        )}
                      </div>
                    </td>
                    <td className="p-0">
                      <div className="flex items-center py-3 px-6 max-w-44 ml-auto">
                        <ButtonPrimary
                          type="button"
                          title={
                            myRuins &&
                            myRuins?.stalkedItems?.find(
                              (v: any) => v.rune_name === rune?.rune_name
                            )
                              ? "Unstake"
                              : "Stake"
                          }
                          //title={stakedCollections[index] ? "Unstake" : "Stake"}
                          onClick={() =>
                            handleStakeUnstakeCollection(
                              index,
                              rune,
                              myRuins?.stalkedItems?.find(
                                (v: any) => v.rune_name === rune?.rune_name
                              )
                            )
                          }
                          // title={stakedRunes[index] ? "Unstake" : "Stake"}
                          // onClick={() => handleStakeUnstakeRune(index)}
                        />
                      </div>
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      </div>
    </figure>
  );
};
